import Header from "../../header/Header";
import WelcomeToInfo from "../welcome_to_info/WelcomeToInfo";
import Footer from "../../footer/Footer";


function WelcomeToLanding(){
    return(
        <div className="welcome_to_landing">
            <Header />
            <WelcomeToInfo />
            <Footer />
        </div>
    )
}

export default WelcomeToLanding